export default "__VITE_ASSET__6714b632__"